/* eslint-disable */
import axios from 'axios';


export default {

    state : {
        debitOrders : [],
        debitAttempt : 0,
        maxDebitAttempt : 3,
        debitBills : [],
    },

   
    getters : {

        allDebitOrders(state) {
            return state.debitOrders;
        },

        getDebitBillById: (state) => (id) => {
            return state.debitBills.find(bill => bill.id === id)
        }

    },

    mutations: {

        setDebitOrders(state, data) {
            state.debitOrders = data;
        },

        setDebitAttempt(state, val) {
            state.debitAttempt = val;
        },
        setDebitBills(state, data) {
            state.debitBills = data;
        },

    },

    actions : {

        
        getDebitOrders({dispatch, commit, rootState, state}) {

            return new Promise((resolve, reject)=>{    
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.token;

                axios.get('/debitOrders') //получаем последний 50 записей
                    .then(response => {
                        commit('setDebitOrders', response.data.orders);
                        commit('setDebitBills', response.data.bills)
                        commit('setDebitAttempt', 0);
                        resolve(response.data.orders);
                    })
                    .catch(error => {
                        console.log(error);
                        if ((error.response.status == 401)||(error.response.status == 500)) {
                            console.log(error);
                        }
                        else {
                            let t = error.response.status == 429 ? 15000 : 1500;  
                            if (error.response.headers["retry-after"] != undefined) t = error.response.headers["retry-after"];
                            if (state.debitAttempt < state.maxDebitAttempt) {
                                commit('setDebitAttempt', state.debitAttempt + 1);
                                setTimeout(()=>{        // повторная загрузка через секунду
                                    dispatch('getDebitOrders');
                                }, t);

                            }
                        }
                        reject(error.response.status)
                    });
            });

        },



    }

}